import { IBooking, ITableItem, IToastDialogProps } from 'shared-types';
import { ToastDialogCleanProps } from 'design-v2/common/ToastDialogClean/types';

export interface IBookingCreatorSlidingStates {
  slideState: SlidingStatesEnum;
  mode?: string;
  showToast?: boolean;
  toastPayload?: IToastDialogProps;
  toastCleanPayload?: ToastDialogCleanProps;
  routeStatus?: string;
  isShowingNewBlockout: boolean;
  showNewVenueSelector?: boolean;
  showEditCustomer?: boolean;
  isReadyForViewActions?: boolean;
  showBlockoutByService?: boolean;
  showBlockoutBySectionOnFp?: boolean;
  showBlockout?: boolean;
  showBlockoutOnFp?: boolean;
  showBlockoutTimePicker?: boolean;
  showSharedTableModal?: boolean;
  sharedTableModalPayload?: ISharedTableModalPayload;
  showBookingConflictsModal?: boolean; // used to show the booking conflicts modal
  conflictTableId?: string; // used to show the table Id which has booking conflicts
  refreshHiddenService?: boolean; // used to refresh the hidden service list
}
export interface ISharedTableModalPayload {
  bookings: IBooking[];
  table: ITableItem;
}

export enum SlidingStatesEnum {
  BCSlideInComplete = 'BCSlideInComplete',
  SlideOutComplete = 'SlideOutComplete',
  BCSlidingIn = 'BCSlidingIn',
  BCSlidingOut = 'BCSlidingOut',
  NoteSlidingOut = 'NoteSlidingOut',
  NoteSlideInComplete = 'NoteSlideInComplete',
  NoteSlidingIn = 'NoteSlidingIn',
  PaymentLinkIn = 'PaymentLinkIn',
  PaymentLinkOut = 'PaymentLinkOut',
  PaymentLinkInComplete = 'PaymentLinkInComplete',
  BlockoutSlideInComplete = 'BlockoutSlideInComplete',
  BlockoutSlidingIn = 'BlockoutSlidingIn',
  BlockoutSlidingOut = 'BlockoutSlidingOut',
}
